import styled from "styled-components";
export const Container = styled.div`
  margin-top: 150px;
  margin-bottom: 50px;
`;
export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 100px;
  margin-left: 100px;
  margin-right: 100px;
  gap: 50px;
  align-items: center;
  @media (max-width: 575px) {
    margin: 0px;
  }
`;

export const InnerTopContainer = styled.div``;

export const Heading = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;
`;
export const Description = styled.p`
  font-size: 32px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
`;

export const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media (max-width: 575px) {
    grid-template-columns: 1fr;
    grid-column-gap: 15px;
    margin: 0px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: end;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ImageContainer = styled.img`
  width: 100%;
`;

export const Button = styled.button`
  width: 170px;
  height: 60px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 3px solid #565656;
  border-radius: 8px;
  opacity: 1;
  cursor: pointer;
`;
